















































import { defineComponent, PropType, computed } from '@vue/composition-api';
import router from '@/router';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import { UBT_COMMON_HOME_PAGE_SIGN } from '@/pages/home/constant';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { RouterV2Enum } from '@/router/router-names';
import { GeneralConfig } from '@/pages/home/config/types';

export default defineComponent({
  name: 'KnowFinancePanel',
  components: {
    RightArrowOutline12,
  },
  props: {
    config: {
      type: Object as PropType<GeneralConfig>,
      required: false,
    },
  },
  setup(props) {
    const financeTitle = computed(() => `认识${props.config?.productName || '哈啰臻有钱'}`);
    /** 授信指南 */
    const onCreditClick = () => {
      ubtSetupPageButton('finance_grant_credit', {
        label: UBT_COMMON_HOME_PAGE_SIGN,
      });
      router.app.$router.push({
        path: RouterV2Enum.usingGuid,
        query: {
          index: '0',
        },
      });
    };
    /** 如何提现 */
    const onWidthrawClick = () => {
      ubtSetupPageButton('finance_widthraw', {
        label: UBT_COMMON_HOME_PAGE_SIGN,
      });
      router.app.$router.push({
        path: RouterV2Enum.usingGuid,
        query: {
          index: '1',
        },
      });
    };

    /** 如何还款 */
    const onRepayClick = () => {
      ubtSetupPageButton('finance_pay_money', {
        label: UBT_COMMON_HOME_PAGE_SIGN,
      });
      router.app.$router.push({
        path: RouterV2Enum.usingGuid,
        query: {
          index: '2',
        },
      });
    };
    /** 了解我们 */
    const onAboutUsClick = () => {
      ubtSetupPageButton('finance_aboutUs', {
        label: UBT_COMMON_HOME_PAGE_SIGN,
      });
      router.app.$router.push({
        path: RouterV2Enum.aboutUs,
      });
    };

    return {
      financeTitle,

      onCreditClick,
      onWidthrawClick,
      onRepayClick,
      onAboutUsClick,
    };
  },
});
